import { Component, ChangeDetectionStrategy } from '@angular/core';
import { BasePaths } from 'src/app/constants/routes';
import {
  PrivacyPolicyTitle,
  PrivacyPolicyTitleJsonKey,
  PrivacyPolicyText,
  PrivacyPolicyTextJsonKey,
} from 'src/app/constants/static-text';

@Component({
  selector: 'mwp-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PrivacyPolicyComponent {
  public returnLink: string = BasePaths.Members;
  public privacyPolicyTitle: string = PrivacyPolicyTitle;
  public privacyPolicyTitleJsonKey: string = PrivacyPolicyTitleJsonKey;
  public privacyPolicyText: string = PrivacyPolicyText;
  public privacyPolicyTextJsonKey: string = PrivacyPolicyTextJsonKey;

  constructor() {}

  download() {
    window
      .open(
        'https://www.myworkplace.net/imagesclient/assets/MyWorkplacePrivacyPolicy.pdf',
        '_blank'
      )
      .focus();
  }
}
